import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiChip, { ChipProps } from '@material-ui/core/Chip';

const FollowChip: React.FC<ChipProps & { checked: boolean }> = withStyles(
  (theme) => ({
    root: {
      position: 'absolute',
      top: 4,
      right: 4,
      zIndex: 10,
    },
    labelSmall: {
      fontSize: theme.typography.pxToRem(12),
    },
    outlined: {
      backgroundColor: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.common.white + ' !important',
      },
    },
  }),
)(({ checked, ...props }) => (
  <MuiChip
    {...props}
    color="primary"
    variant={checked ? 'default' : 'outlined'}
  />
));

export default FollowChip;
